import { FaArrowRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { Navigate } from "react-router-dom";
import {useDispatch} from "react-redux";
import {addToCart} from "../redux/bazarSlice"
import { ToastContainer,toast } from "react-toastify";
const ProductsCard=({product})=>{
    const dispatch=useDispatch()
    const navigate=useNavigate()
   const _id=product.title;
  const idString=(_id)=>{
    return String(_id).toLowerCase().split(" ").join("")
  }
  const root_id=idString(_id);
     const handleDetails=()=>{
        navigate(`/Product/${root_id}`,{
            state:{
                item:product,
            }
        })
    }
    return(<div className="relative" >
    <div onClick={handleDetails} className="w-full h-96 cursor-pointer overflow-hidden relative">
        <img src={product.image} className="w-full h-full object-cover hover:scale-110 duration-500 "alt="" />
    </div>

    <div className="w-full border-[1px] px-2 py-4">
   <div className="flex justify-between items-center">

   <div>
    <h2 className="font-titleFont text-base font-bold">{product.title.substring(0,15)}</h2>
    </div>

    <div className="flex   gap-2 h-[30px]  overflow-y-hidden ">
    <div className="flex flex-col hover:-translate-y-[27px] duration-300">
     <div className="flex ">
    <p className="line-through text-gray-500 mx-3">${product.oldPrice}</p>
    <p className="font-semibold mx-2">${product.price}</p>
    </div>
    <div className=" my-2 flex gap-3 items-center cursor-pointer">
    <p onClick={()=>dispatch(addToCart({
        _id:product.title,
        image:product.image,
        price:product.price,
        quantity:1,
        description:product.description,
    }))&& toast.success(`${product.title} is added`)} >AddTocart</p> 
    <span><FaArrowRight></FaArrowRight></span>
    </div>
    </div>
    
    </div>
  
    </div>
    <p>{product.category}</p>
    <div className="absolute top-4 right-2">
    {
        product.isNew&&(
            <p className="bg-black text-white font-semibold font-titleFont px-6 py-1 ">Sale</p>
        )
    }
   </div>
   </div>
   <ToastContainer
     position="top-left"
     autoClose={2000}
     hideProgressBar={false}
     newestOnTop={false}
     closeOnClick
     rtl={false}
     pauseOnFocusLoss
     draggable
     pauseOnHover
     theme="dark"
    >
    </ToastContainer>
    </div>)
}
export default ProductsCard;